<template>
  <div class="bcoopera">
      <Navbar></Navbar>
      <div class="contents">
          <div class="bg"></div>
          <div class="content">
              <div class="middle">
                  <div class="aboutus">
                      <span class="line"></span>
                      <div class="title">商务合作</div>
                      <p>BUSINESS COOPERATION</p>
                      <span class="line"></span>
                  </div>
                <form action="" method="" class="form" @submit.prevent="sub()" style="display: none;">
                    <div class="name">
                        <div class="name-item">您的称呼<div class="name-star">*</div></div>
                        <input type="text" name="username" maxlength="15" placeholder="请输入您的称呼" required v-model="input1" v-on:focus="insinte()">
                    </div>
                    <div class="phone">
                        <div class="name-item">您的电话<div class="name-star">*</div></div>
                        <input type="text" name="username" maxlength="11" placeholder="请输入您的电话" required v-model="input2" v-on:focus="insinte()" onkeyup="this.value=this.value.replace(/\D/g,'')">
                    </div>
                    <div class="require">
                        <div class="name-item">写下您的建议和需求<div class="name-star">*</div></div>
                        <textarea name="require" id="text" placeholder="请写下您的建议和需求，我们将会通过您留下的联系方式联系您" v-model="input3" required v-on:focus="insinte()"></textarea>
                    </div>
                    <div class="bottons" ><button type="submit" class="submit" >提交留言</button></div>
                </form>

                  <div class="photo"></div>
                  <div class="tojoin">
                      <p class="one" oncontextmenu="return false">我们期待您的加盟！加盟方式，包括不限于：代理商加盟、ORM合作、API对接、定制开发、广告合作</p>
                      <p class="three" oncontextmenu="return false">我们期待您的加盟！加盟方式<br/>包括不限于：代理商加盟、ORM合作、API对接、定制开发、广告合作</p>
                      <p class="two">商务邮箱：<a oncopy="return true" onpaste="return true" oncontextmenu="return true" >marketing@weimaqi.com</a> &nbsp;&nbsp;商务电话：<a oncopy="return true" onpaste="return true" oncontextmenu="return true" >400-900-5939</a></p>
                  </div>
                  
              </div>
              <thr></thr>
          </div>
           
      </div>
     <foot></foot>
  </div>
</template>

<script>
import Navbar from '../Navbar'
import Foot from '../hardProduct/foot'
import Thr from './thr'
export default {
  name:'BCoopera',
  components:{Navbar,Foot,Thr},
      data(){
          return{
              input1:'',
              input2:'',
              input3:'',
          }
      },
      methods:{
           sub(){
               if(this.input2.length !== 11){alert('请填写正确的手机号码')};
               if(this.input1 !== '' && this.input2 !== '' &&this.input2.length == 11 && this.input3 !== ''){
                   alert('提交成功');
               }else{
                   alert('请先填写完信息在提交');
              };
              
           },
           insinte(){
               this.$store.state.d5 = false;
               this.$store.state.d6.style.display = 'none';
           },
      }
  }

</script>


<style scoped>
/* .contents .bg .header{
    position: absolute;
    z-index: 0;
} */
.tojoin .three{
    display: none;
}
.contents{
    width: 100%;
}
.contents .bg{
    width: 100%;
    height: 800px;
    background: url(./images/bg4.jpg) no-repeat;
    background-size: cover;
}
.content{
    width:100%;
    height: 100%;   /*为什么写100%没有高度呢 是因为用了定位，脱离了文档流*/
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.middle{
    width: 1200px;
	height: 1440px;
	background-color: #ffffff;
    margin-top: -200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
}
.aboutus{
    width: 499px;
	height: 133px;
    background: url(images/titlebg.png) no-repeat;
    background-size: 499px 78px;
    background-position: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    margin-top: 100px;
}
.aboutus .line{
    width: 24px;
	height: 3px;
	background-color: #1a8bff;
    display: block;
}
.aboutus .title{
    font-family: 微软雅黑;
    font-size: 40px;
	letter-spacing: 0px;
	color: #333333;
}
.aboutus p{
    font-size: 14px;
	font-family: Arial;
	letter-spacing: 1px;
	color: #333333;
    display: block;
    margin-top: -18px;
}

.form{
    width: 740px;
	height: 455px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-content: space-between;
}
.form .name-item{
    font-size: 16px;
	font-family: 微软雅黑;
	letter-spacing: 0px;
	color: #666666;
    width:350px;
    height: 16px;
    line-height: 16px;
        display: flex;
    justify-content: flex-start;
    position: relative;
}
.name .name-item .name-star,.phone .name-item .name-star{
	color: #ff6666;
        position: absolute;
    top: 3px;
    left: 66px;
}
.require .name-item .name-star{
    color: #ff6666;
    position: absolute;
    top: 3px;
    left: 146px;
}
.form input{
    width: 350px;
	height: 54px;
	border: solid 1px #cccccc;
    padding-left: 10px;
    box-sizing: border-box;
}
.name, .phone{
    width:350px;
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.bottons{
    width: 100%;
    text-align: center;
}
.submit{
    width: 230px;
	height: 66px;
	background-color: #333333;
	border-radius: 10px;
    border: none;
    font-size: 16px;
	font-family: 微软雅黑;
	line-height: 66px;
	letter-spacing: 0px;
    color: #ffffff;
    cursor: pointer;
    outline: 0;
}
.require{
    width: 740px;
	height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.require #text{
    width: 740px;
	height: 166px;
	border: solid 1px #cccccc;
    font-size: 14px;
	font-family: 微软雅黑;
	letter-spacing: 0px;
	color: #333;
    padding-left: 20px;
    padding-top: 22px;
    box-sizing: border-box;
     resize : none;
}
.photo{
    width:1200px;
    height: 460px;
    background: url(images/add.jpg) no-repeat;
    background-size: cover;
}
.tojoin{
    height: 53px;
    line-height: 26px
}
.tojoin p{
    font-size: 16px;
	font-family: 微软雅黑;
	letter-spacing: 0px;
	color: #333333;
    text-align: center;
}
.tojoin .two a{
    color: #1a8bff;
}

/* shouji */
@media screen and (max-width:768px){
    .bcoopera{
        width: 100%;
        overflow-x: hidden;
        margin-top: 48px;
    }
    .content{
        height: auto;
    }
    .contents .bg{
        width: 100%;
    height: 205px;
    background: url(./images/phone/BG4.png) no-repeat;
    background-size: 100%;
    }
    .middle{
    width: 90%;
    height: auto;
    margin-top: -70px;
}
.aboutus{
    width: 80%;
	height: 66px;
    background: url(images/titlebg.png) no-repeat;
    background-size: 249px 39px;
    background-position: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    margin-top: 35px;
}
.aboutus .line{
    width: 12px;
	height: 1.5px;
	background-color: #1a8bff;
    display: block;
}
.aboutus .title{
    font-family:'Times New Roman', Times, serif;
    font-size: 20px;
	letter-spacing: 0px;
	color: #333333;
}
.aboutus p{
    font-size: 7px;
	font-family: Arial;
	letter-spacing: 1px;
	color: #333333;
    display: block;
    margin-top: -9px;
}
.form{
    width: 90%;
    height: auto;
        margin-top: 40px;
}
.form .name-item{
    font-size: 11px;
    letter-spacing: 0.5px;
    color: #333;
}
.form input{
    height: 40px;
    width: 100%;
    border: solid 1px #333333;
    -webkit-appearance:none;/*清除ios默认圆角*/
    border-radius:0;
}
.form input::-webkit-input-placeholder,.require #text::-webkit-input-placeholder{
    font-size: 11px;
    color: #ccc;
    letter-spacing: 0.5px;
}
.name,.phone{
    width: 45%;
    height: 60px;
}
.require{
    width: 100%;
    height: 170px;
    margin-top: 10px;
}
.require #text{
    width: 100%;
    height: 150px;
    box-sizing: border-box;
     border: solid 1px #333333;
    padding-left: 10px;
    padding-top: 11px;
    -webkit-appearance:none;/*清除ios默认圆角*/
    border-radius:0;
}
.bottons{
    margin-top: 15px;
}
.submit{
    font-size: 12px;
    letter-spacing: 0.5px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 0px;
}
.middle .photo{
    width: 100%;
    height: 230px;
    background: url(./images/phone/ADD.png) no-repeat;
    background-size: 100%;
    background-position: center;
    margin-top: 40px;
    margin-bottom: 25px;
}
.name .name-item .name-star, .phone .name-item .name-star{
    left: 55px;
}
.require .name-item .name-star{
    left: 120px;
}
.tojoin{
    height: 49px;
    line-height:17px;
}
.tojoin .one{
    display: none;
}
.tojoin .three{
    display: block;
    font-size: 11px;
    color: #333;
    letter-spacing: -0.6px;
}
.tojoin .two{
    font-size: 11px;
    color: #333;
}
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs/BCoopera.vue